import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Tooltip from '@material-ui/core/Tooltip'
import HelpIcon from '@material-ui/icons/Help'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import {
  fetchPolicyEditorList,
  updateNotificationSubscribers,
} from 'reducers/monitorsAndAlerts/reducer'
import { fetchUserList } from 'reducers/slaMonitor/reducer'
import UserSelect from './UserSelect'
import messages from '../../translate'

class PolicyEditor extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      activeSite: prevActiveSite,
      activeLocus: prevActiveLocus,
    } = this.props
    const { activeSite, activeLocus } = nextProps

    this.loadingData = nextProps.tableLoader

    if (activeSite !== prevActiveSite || activeLocus !== prevActiveLocus) {
      const site = activeSite.get('id')
      const locus = activeLocus.get('id')

      this.getTableData(site, locus)

      return false
    }

    return super.shouldComponentUpdate(nextProps, nextState)
  }

  componentDidMount() {
    const { activeSite, activeLocus, fetchUserList } = this.props
    const site = activeSite.get('id')
    const locus = activeLocus.get('id')

    fetchUserList()
    this.getTableData(site, locus)
  }

  getTableData = (site, locus) => {
    const { fetchPolicyEditorList } = this.props

    if (!!locus && !!site) {
      fetchPolicyEditorList({ site, locus })
    } else if (site) {
      fetchPolicyEditorList({ site })
    } else {
      fetchPolicyEditorList()
    }
  }

  getTableProps = () => ({
    showFilterBar: false,
    sorting: false,
    paging: false,
    searching: false,
    creating: false,
    className: 'ma-editor',
  })

  getSendToLabel = () => {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <span className="notification-label">
        {formatMessage(messages.sendNotificationsTo)}
        <Tooltip
          placement="top"
          title={formatMessage(messages.notificationInfo)}>
          <HelpIcon fontSize="small" color="primary" />
        </Tooltip>
      </span>
    )
  }

  getColumns() {
    const {
      intl: { formatMessage },
      userList,
      updateNotificationSubscribers,
      activeSite,
      activeLocus,
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('name', formatMessage(messages.policyName), {
        render: ({ policy: { name } }) => name,
      }),
    )
    columns.add(
      new Column('details', formatMessage(messages.policyDetails), {
        render: ({ policy: { details } }) => details,
      }),
    )
    columns.add(
      new Column('sendTo', this.getSendToLabel(), {
        render: (rowData, rowKey) => (
          <UserSelect
            rowKey={rowKey}
            rowData={rowData}
            userList={userList}
            activeSite={activeSite.get('id')}
            activeLocus={activeLocus.get('id')}
            formatMessage={formatMessage}
            saveMethod={updateNotificationSubscribers}
          />
        ),
      }),
    )

    return columns
  }
}

export default connect(
  state => ({
    userList: state.getIn(['slaMonitor', 'userList']),
    activeSite: state.getIn(['monitorsAndAlerts', 'activeSite']),
    activeLocus: state.getIn(['monitorsAndAlerts', 'activeLocus']),
    tableData: state.getIn(['monitorsAndAlerts', 'policyEditorList']),
    tableLoader: state.getIn(['monitorsAndAlerts', 'isLoadPolicyEditorTable']),
  }),
  {
    fetchPolicyEditorList,
    fetchUserList,
    updateNotificationSubscribers,
  },
)(injectIntl(PolicyEditor))
